import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4b50242&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f4b50242&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cac_q4nveoxp7n4czahn54be2wnk2a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b50242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\new-site\\wetech-website-admin\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4b50242')) {
      api.createRecord('f4b50242', component.options)
    } else {
      api.reload('f4b50242', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f4b50242&scoped=true", function () {
      api.rerender('f4b50242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading/index.vue"
export default component.exports